<template>
	<div :class="['font-size-8 text-left', typeClass]" role="alert">
		<span v-html="message" />
		<button type="button" class="pt-0 pb-0 pl-1 btn " aria-label="Close" @click="$emit('close')" v-if="close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
</template>

<script>
	export default {
		props: {
			type: {
				type: String,
				default: 'error',
			},
			message: {
				type: String,
				default: '',
			},
			close: {
				type: Boolean,
				default: false,
			},
		},
		computed: {
			typeClass() {
				switch (this.type) {
					case 'success':
					return 'color-green';
					case 'warning':
					return 'color-yellow';
					case 'info':
					return 'color-blue';
					default:
					return 'color-red';
				}
			},
		},
	};
</script>

<style scoped>
.close {
	float: none;
	position: absolute;
	right: 10px;
	top: 10px;
}
</style>
